import { render } from "./CustomVendorInterface.vue?vue&type=template&id=40be8e0e"
import script from "./CustomVendorInterface.vue?vue&type=script&lang=js"
export * from "./CustomVendorInterface.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__